import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/sharp-solid-svg-icons';
import { Placement } from '@popperjs/core';
import { FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonSize } from '@/components/button';
import DropDownButton from '@/components/dropDownButton';
import { OverflowMenuItem } from '@/components/dropDownButton/menuItem';
import useParcelsToBoundaries from '@/features/boundaries/util/parcelsToBoundaries';
import { AcresFeature } from '@/models/features';
import { useAuth } from '@/providers/auth-provider';

type Props = {
  features: AcresFeature[];
  buttonClassName?: string;
  className?: string;
  placement?: Placement;
};

export const DropdownHeaderOverflowMenu: FC<Props> = ({
  buttonClassName = '',
  className = '',
  placement = 'bottom-end',
  features,
}) => {
  const { isAnonymous } = useAuth();

  const { combineAdjacentFeaturesV2, convertToBoundaries } =
    useParcelsToBoundaries();

  const convertLabel = useMemo(() => {
    return features?.length > 1
      ? 'Convert to Boundaries'
      : 'Convert to Boundary';
  }, [features?.length]);

  const menuOptions: OverflowMenuItem[] = useMemo(() => {
    const menuItems = [
      {
        id: 'merge-all',
        label: 'Merge All',
        onClick: (e) => {
          e.stopPropagation();
          combineAdjacentFeaturesV2(features);
        },
        value: 'merge-all',
      },
      {
        id: 'convert-to-boundaries',
        label: convertLabel,
        onClick: (e) => {
          e.stopPropagation();
          convertToBoundaries(features);
        },
        value: 'convert-to-boundaries',
      },
    ];

    return features?.length > 1 ? menuItems : menuItems.slice(1);
  }, [convertLabel, features, combineAdjacentFeaturesV2, convertToBoundaries]);

  if (isAnonymous) return null;

  return (
    <DropDownButton
      buttonClassName={twMerge('text-white-100 p-0', buttonClassName)}
      buttonSize={ButtonSize.SMALL}
      className={className}
      groupOptions={[menuOptions]}
      overflowClassName="w-[200px]"
      overflowItemClassName="min-w-[100%]"
      placement={placement}
      variant="light"
    >
      <FontAwesomeIcon className="h-4 w-4" icon={faEllipsisVertical} />
    </DropDownButton>
  );
};
